


















































































import store from '../../store'
import { isIos, isWeixin } from '@ivy/fts/utils'
import ivyPlayer from '../_comps/ivyPlayer.vue'
import openApp from '@ivy/fts/openApp'
import { Component, Vue, Watch } from 'vue-property-decorator'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import showApp from '../../components/showApp.vue'
@Component({
  components: { ivyPlayer }
})

export default class ShareVideo extends Vue {
  videoId: any = null
  video: any = null
  playing: boolean = false
  media: any = null
  hasPlayed: boolean = false
  isIos: boolean = isIos()
  get videoBgStyle() {
    return this.hasPlayed ? '' : `background: no-repeat center/100% url(${this.video.pic_url});`
  }
  get playcount() {
    return this.video.playCount > 9999 ? `${(this.video.playCount / 10000).toFixed(1)}万` : this.video.playCount
  }
  async toApp() {
    showDiv(showApp, {
      closeAll
    })
  }
  onPlay() {
    this.hasPlayed = true
  }
  async playVideo() {
    let playFn = () => {
      let playPromise = this.media.play()
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log(error)
        }).then(() => { })
      }
    }
    if (isWeixin()) {
      document.addEventListener('WeixinJSBridgeReady', playFn, false)
    } else {
      playFn()
    }
    this.playing = true
  }
  toVip() {
    return this.$router.push('/vip')
  }
  async initVideo() {
    // let { data: video } = await this.$axios.get(`/api/mobile/audios/resource2/videoDetail?id=${this.videoId}&includes=url`)
     let { data: video } = await this.$axios.get(`/api/mobile/content/video/getById?id=${this.videoId}`)
     this.video = video
  }
  async mounted() {
    this.videoId = this.$route.query.id
    await this.initVideo()
    this.media = this.$refs.videoObj
    await store.setupShare({ imgUrl: `${this.video.picUrl}?x-oss-process=image/resize,w_750`, desc: this.video.detail === '' ? '致力于为中国孩子提供优质音视频内容' : this.video.detail, title: `我和宝宝正在「常青藤爸爸」看「${this.video.title}」` })
  }
}
